var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue100vh',{attrs:{"id":"hero"}},[_c('Navbar'),_c('NavbarBlock'),_c('HeroContent'),_c('HeroImage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }